import { useNavigate } from "react-router-dom";

const DISENO_PATH = "/administracion/tienda/diseno";

// Tarjeta de acceso al editor de diseño inmersivo (pantalla completa).
export default function BrandingLauncher() {
  const navigate = useNavigate();

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.icon} aria-hidden>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3a9 9 0 1 0 0 18c.9 0 1.5-.7 1.5-1.5 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1 0-.8.7-1.5 1.5-1.5H16a4 4 0 0 0 4-4c0-4.4-3.6-7.3-8-7.3Z" />
            <circle cx="7.5" cy="11" r="1.1" />
            <circle cx="10.5" cy="7.5" r="1.1" />
            <circle cx="14.5" cy="7.5" r="1.1" />
          </svg>
        </div>
        <h3 style={styles.title}>Editor de diseño</h3>
        <p style={styles.desc}>
          Personaliza los colores del encabezado y el pie de página de tu tienda en un
          editor a pantalla completa, con vista previa en vivo.
        </p>
        <button type="button" style={styles.btn} onClick={() => navigate(DISENO_PATH)}>
          Abrir editor de diseño
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex",
    justifyContent: "center",
    padding: "24px 0",
  },
  card: {
    maxWidth: 560,
    width: "100%",
    textAlign: "center",
    padding: "36px 28px",
    borderRadius: 22,
    background: "linear-gradient(180deg,#ffffff 0%,#f8fbff 100%)",
    border: "1px solid #e2e8f0",
    boxShadow: "0 14px 36px rgba(15,23,42,0.06)",
  },
  icon: {
    width: 64,
    height: 64,
    margin: "0 auto 6px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 18,
    background: "#ecfeff",
    border: "1px solid #a5f3fc",
    color: "#0891b2",
  },
  title: {
    margin: "8px 0 0",
    fontSize: 22,
    fontWeight: 900,
    letterSpacing: "-0.03em",
    color: "#0f172a",
  },
  desc: {
    margin: "10px auto 22px",
    maxWidth: 440,
    fontSize: 14,
    lineHeight: 1.6,
    color: "#64748b",
  },
  btn: {
    border: 0,
    borderRadius: 14,
    background: "#0891b2",
    color: "#fff",
    fontSize: 14,
    fontWeight: 900,
    padding: "13px 26px",
    cursor: "pointer",
    boxShadow: "0 16px 30px rgba(8,145,178,0.22)",
  },
};
